const BankAccountState = {
    bankAccounts: {},
    banks: [],
    banksWithUSSD: [],
};

export default BankAccountState;